/**
 * Input Schema of ResponsavelUsuario
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {ResponsavelUsuario} from '@/model/resource/ResponsavelUsuario'
import {TipoResponsavelUsuarioCollection} from '@/model/collection/TipoResponsavelUsuarioCollection'

export class InputResponsavelUsuarioSchema extends Schema {
  readonly name = 'InputResponsavelUsuario'

  readonly fieldSet: FieldSet<ResponsavelUsuario> = {
    nome: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    email: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'email',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    senha: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'password',
        maxlength: 1023,
        label: this.translateFrom(schema.fieldName),
        validation: 'min:6',
        required: schema.model.ehCriacao,
      },
    }),
    tipoResponsavelUsuarioAsResource: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        type: 'text',
        label: this.translateFrom(schema.fieldName),
        items: new TipoResponsavelUsuarioCollection().options().all(),
        required: true,
        validation: 'required',
      },
    }),
    permitirCadastrarUsuario: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
  }
}
